module.exports = __webpack_public_path__ + "static/media/constructo-logo.cb12d564.jpeg";